/* app/js/src/components/content-control/operation-room/content-control-operation-room-player/content-control-operation-room-player.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
}
:host::ng-deep ::cue {
  background-color: rgba(0, 0, 0, 0.75);
  color: white;
  display: block;
  width: 100%;
  padding: 2px 8px;
}
.dropbox {
  aspect-ratio: 16/9;
  width: 100%;
  height: max-content;
  max-width: 100%;
  border-radius: 1px;
}
.dropbox .empty-screen {
  border: 2px dotted rgba(0, 0, 0, 0.14);
  position: relative;
  height: 100%;
  width: 100%;
}
.dropbox .empty-screen .add {
  background: #ffffff;
  padding: 67.72px 127.8px 67.72px 127.8px;
  display: flex;
  flex-direction: row;
  gap: 4.77px;
  align-items: center;
  justify-content: center;
  width: 100.15%;
  height: 100.23%;
  position: absolute;
  right: -0.04%;
  left: -0.1%;
  bottom: -0.11%;
  top: -0.11%;
}
.dropbox .empty-screen .add svg {
  flex-shrink: 0;
  width: 19.43px;
  height: 19.43px;
  position: relative;
  overflow: visible;
}
.dropbox .empty-screen .add svg path {
  fill: rgb(194, 204, 219);
}
.dropbox .player {
  display: flex;
  flex-direction: column;
  gap: 0px;
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  flex-shrink: 0;
  gap: 0;
  background: #232f3a;
}
.dropbox .player.fullscreen .top-bar svg:not(.progress-svg),
.dropbox .player.fullscreen .controls svg:not(.progress-svg) {
  scale: 2;
}
.dropbox .player.fullscreen .top-bar span,
.dropbox .player.fullscreen .controls span {
  font-size: 16px !important;
}
.dropbox .player.fullscreen .top-bar > div {
  padding: 0 20px;
}
.dropbox .player.fullscreen .controls {
  flex: 0 0 10%;
}
.dropbox .player.fullscreen .controls > div {
  height: 30px;
}
.dropbox .player.fullscreen .video .video-wrapper {
  padding-bottom: 45%;
  margin-top: 5%;
}
.dropbox .player > div {
  width: 100%;
}
.dropbox .player > div svg {
  cursor: pointer;
}
.dropbox .player .top-bar {
  background: #525e9a;
  display: flex;
  flex: 0 0 5%;
}
.dropbox .player .top-bar .expand-screen {
  display: flex;
  padding: 0px 4.463px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-right: 0.893px solid var(--Color-White, #fff);
}
.dropbox .player .top-bar .expand-screen svg {
  display: flex;
  padding: 1.785px;
  justify-content: center;
  align-items: center;
}
.dropbox .player .top-bar .title {
  display: flex;
  padding: 0px 4.463px;
  align-items: center;
  flex: 1 0 0;
  align-self: stretch;
}
.dropbox .player .top-bar .title span {
  color: #ffffff;
  font-family: "Open Sans";
  text-transform: uppercase;
  font-size: 8.033px;
  font-style: normal;
  font-weight: 400;
  line-height: 12.495px;
}
.dropbox .player .top-bar .assets-container {
  display: flex;
  padding-left: 4.463px;
  align-items: center;
  align-self: stretch;
  border-left: 0.893px solid var(--Color-White, #fff);
}
.dropbox .player .top-bar .assets-container .frame {
  display: flex;
  flex-direction: row;
  gap: 1.785px;
  align-items: center;
  justify-content: flex-start;
}
.dropbox .player .top-bar .assets-container .frame .icon-mute {
  display: flex;
  padding: 2.678px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8.925px;
  border-radius: 1.785px;
  background: rgba(255, 255, 255, 0.1);
}
.dropbox .player .top-bar .assets-container .frame .icon-mute svg {
  flex-shrink: 0;
  position: relative;
  overflow: visible;
}
.dropbox .player .top-bar .assets-container .frame select {
  background-color: transparent;
  color: #ffffff;
  text-align: left;
  font-size: 8.033px;
  font-style: normal;
  font-weight: 400;
  line-height: 12.495px;
  position: relative;
  outline: none;
  text-transform: uppercase;
  border: none;
}
.dropbox .player .top-bar .assets-container .frame select option {
  background: #525e9a;
  color: #ffffff;
}
.dropbox .player .top-bar .close {
  display: flex;
  width: 20.43px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-left: 0.893px solid var(--Color-White, #fff);
}
.dropbox .player .top-bar .close svg {
  flex-shrink: 0;
}
.dropbox .player .video {
  flex-grow: 1;
  max-width: 100%;
  margin: 0 auto;
  position: relative;
}
.dropbox .player .video .video-wrapper {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
}
.dropbox .player .video .video-wrapper video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.dropbox .player .video .video-wrapper canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  pointer-events: none;
}
.dropbox .player .video .video-wrapper .custom-subtitles {
  position: absolute;
  bottom: 60px;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 2;
  pointer-events: none;
  background-color: rgba(0, 0, 0, 0.75);
  color: white;
  font-size: 16px;
  padding: 8px 16px;
  margin: 0 auto;
  max-width: 80%;
  width: fit-content;
  border-radius: 4px;
  white-space: pre-line;
}
.dropbox .player .controls {
  flex: 0 0 5%;
  display: flex;
  padding: 3.57px;
  align-items: center;
  gap: 1.785px;
  align-self: stretch;
}
.dropbox .player .controls > div {
  height: 10.71px;
  cursor: pointer;
  background-color: rgba(255, 255, 255, 0.1);
}
.dropbox .player .controls .progress-container {
  position: relative;
  width: 100%;
  flex: 1 0 0;
}
.dropbox .player .controls .progress-container .progress-svg {
  position: absolute;
  width: 100%;
  height: 100%;
}
.dropbox .player .controls .progress-container .seek-overlay {
  position: absolute;
  top: -10px;
  left: 0;
  right: 0;
  bottom: -10px;
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.dropbox .player .controls .progress-container .time-tooltip {
  position: absolute;
  transform: translateX(-50%) translateY(-100%);
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  pointer-events: none;
  margin-top: -8px;
}
.dropbox .player .controls .progress-container .time-tooltip:after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: -4px;
  transform: translateX(-50%);
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid rgba(0, 0, 0, 0.8);
}
.dropbox .player .controls .full-screen {
  display: flex;
  flex: 0 0 2.5%;
  justify-content: center;
  align-items: center;
  gap: 5.107px;
}
.dropbox .player .controls .live {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 5%;
  transition: color 0.2s ease;
  -webkit-user-select: none;
  user-select: none;
  cursor: pointer;
}
.dropbox .player .controls .live:hover {
  color: rgba(255, 255, 255, 0.8);
}
.dropbox .player .controls .live.is-live {
  color: #ffffff;
  cursor: auto;
}
.dropbox .player .controls .live span {
  text-align: center;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Open Sans";
  font-size: 5.355px;
  font-style: normal;
  font-weight: 700;
  line-height: 8.925px;
  text-transform: uppercase;
}
.dropbox .player .controls .play {
  display: flex;
  flex: 0 0 2.5%;
  justify-content: center;
  align-items: center;
  gap: 5.107px;
}
.dropbox .player .controls .play svg {
  width: 6.248px;
  height: 6.248px;
}
/*# sourceMappingURL=content-control-operation-room-player.component.css.map */
